/*
* Статусы, при которых доступны определенные действия
* */

export const insureCargoTrade = ['created', 'edited', 'edit_request', 'accepted'];
export const cancelTrade = ['demo', 'created', 'edited', 'edit_request', 'accepted', 'cargo_loaded'];
export const arbitrationTrade = ['money_reserved', 'started_route', 'cargo_unload', 'complete'];
